export interface IPasswordFormField {
  name: string;
  label: string;
  className: string;
  placeholder: string;
}

export interface IPasswordForm {
  oldPassword: IPasswordFormField;
  newPassword: IPasswordFormField;
  repeatPassword: IPasswordFormField;
  [key: string]: IPasswordFormField;
}

export const passwordFormFields: IPasswordForm = {
  oldPassword: {
    name: 'oldPassword',
    label: 'global.password.old',
    placeholder: 'global.password.old.placeholder',
    className: 'mb-3',
  },
  newPassword: {
    name: 'password',
    label: 'global.password.new',
    placeholder: 'global.password.new.placeholder',
    className: 'mb-3',
  },
  repeatPassword: {
    name: 'repeatPassword',
    label: 'global.password.repeat',
    placeholder: 'global.password.repeat.placeholder',
    className: 'mb-2',
  },
};

export const passwordFormFieldsValues: IPasswordFormField[] = Object.values(passwordFormFields);

export interface INewPasswordRule {
  name: string;
  description: string;
  validate: (value: string) => boolean;
}

export const newPasswordRules: INewPasswordRule[] = [
  {
    name: 'minLength',
    description: 'errors.password.minLength',
    validate: (value) => value?.length > 7,
  },
  {
    name: 'uppercaseRequired',
    description: 'errors.password.uppercaseRequired',
    validate: (value) => /[A-Z]/.test(value),
  },
  {
    name: 'lowercaseRequired',
    description: 'errors.password.lowercaseRequired',
    validate: (value) => /[a-z]/.test(value),
  },
  {
    name: 'numberRequired',
    description: 'errors.password.numberRequired',
    validate: (value) => /\d/.test(value),
  },
];
